// extracted by extract-css-chunks-webpack-plugin
module.exports = {"siteMapList":"StaticSiteMap__siteMapList--FAJ-I","siteMapItem":"StaticSiteMap__siteMapItem--EkwbV"};